<template>
  <div class="Div">
    <section class="sectionContent">
      <labars-bread></labars-bread>
      <div class="details">
        <div class="title">
          <p class="pt">
            {{swiperImgList.album_title_cn}}
          </p>
          <p class="p" v-if="swiperImgList.timeCopywriting">
            {{swiperImgList.timeCopywriting}}：
            <span>{{swiperImgList.send_time}}</span>
          </p>
        </div>
        <div class="facility">
          {{swiperImgList.album_sketch_cn}}
        </div>
        <div
          class="content"
          v-if="swiperImgList.imgList.length>0"
        >
          <div
            class="swiper-button-prev"
            @click="pageClick(1)"
          >
            <i class="el-icon-arrow-left"></i>
          </div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <img
            class="enlargedImg"
            :src="swiperImgList.imgList[swIndex]"
            alt=""
          >
          <div
            class="swiper-button-next"
            @click="pageClick(2)"
          >
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="total">
            {{swIndex+1}}/{{swiperImgList.imgList.length}}
          </div>
        </div>
        <div class="div" v-if="swiperImgList.imgList.length>0">
          <swiper
            ref="mySwiper"
            :options="swiperOption"
            class="myswiper "
          >
            <!-- swiper-no-swiping禁止拖拽类名 -->
            <swiper-slide
              class="swiperslide"
              v-for="(item,i) of swiperImgList.imgList"
              :key='i'
            >
              <div
                class="swiperDiv"
                @click="swiperClick(i)"
              >
                <!-- @mouseenter="onEnter"
                @mouseleave="onLeave" -->
                <img
                  class="foodImg"
                  :src="item"
                  alt=""
                >

              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-prev"
            @click="pageClick(1)"
          ><img
              src="../../../static/image/left2.png"
              alt=""
              srcset=""
            ></div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div
            class="swiper-button-next"
            @click="pageClick(2)"
          ><img
              src="../../../static/image/right2.png"
              alt=""
              srcset=""
            ></div>
          <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        </div>
        <div class="notGall" v-if="swiperImgList.imgList.length<1">
          暂无图片
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import LabarsBread from "../../layout/LabarsBread";
let _that;
import { albumDetails } from "@/api/Album";
export default {
  name: "GalleryDetail",

  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        initialSlide: 0,
        autoplay: false,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        centeredSlides: true,
        // centeredSlidesBounds: true,
        effect: "coverflow",
        grabCursor: false,
        slidesPerView: 5,
        // centeredSlides:true,
        // spaceBetween: 0,
        coverflowEffect: {
          rotate: 0,
          stretch: "-10",
          depth: 0,
          modifier: 1,
          slideShadows: false
        },
        // setWrapperSize: true,
        preventClicksPropagation: true,
        // loop: true,
        // loopAdditionalSlides : 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        slideToClickedSlide: true,
        on: {
          slideChange: function() {
            _that.swIndex = this.activeIndex;
            // console.log(this.activeIndex, "释放图片");
            // alert("改变了，activeIndex为" + this.activeIndex);
          }
        }
      }, //swiper参数
      swIndex: 0, //索引
      swiperImgList: {
        imgList: []
      },
      laber: []
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    LabarsBread
  },
  directives: {
    swiper: directive
  },
  computed: {
    ...mapState("user", ["headerHeight"]),
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {
    swiperClick(i) {
      // console.log(i, "点击图片");
      this.swIndex = i;
    },
    // 上一页下一页
    pageClick(i = 0) {
      // console.log(this.swiper.clickedIndex, "拉动");
      if (i == 1) {
        this.swIndex -= 1;
        if (this.swIndex <= 0) {
          this.swIndex = 0;
        }
      } else if (i == 2) {
        this.swIndex += 1;
        if (this.swIndex >= 15) {
          this.swIndex = 15;
        }
      }
      // console.log(this.swIndex, "翻页");
    }
  },
  created() {
    _that = this;
    if (this.$route.query.laber) {
      this.laber = JSON.parse(this.$route.query.laber);
    }
    var id = this.$route.query.id;
    albumDetails({ album_id: id }).then(res => {
      // console.log(res.data);
      if(res.code==1){
        this.swiperImgList = res.data;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  min-height: 100%;
  background: #f5f5f5;
}
.sectionContent {
  width: px2Rem(1300px);
  margin: auto;
  padding: 0.1px 0;
  .details {
    // height: px2Rem(1160px);
    padding: 0.1px;
    margin-bottom: px2Rem(30px);
    background: rgba(255, 255, 255, 1);
    .title {
      padding: px2Rem(30px) px2Rem(30px) px2Rem(16px);
      font-size: px2Rem(34px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      //   text-align: center;
      clear: both;
      .pt {
        display: inline-block;
        width: 71%;
        vertical-align: top;
      }
      .p {
        display: inline-block;
        float: right;
        font-size: px2Rem(28px);
        color: rgba(153, 153, 153, 1);
        span {
          position: relative;
          // top: px2Rem(3px);
        }
      }
    }
    .facility {
      padding: 0 px2Rem(30px) px2Rem(30px);
      margin-bottom: px2Rem(30px);
      border-bottom: 1px solid rgba(241, 241, 241, 1);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
    .enlargedImg {
      display: block;
      width: px2Rem(920px);
      margin: auto;
    }
    .total {
      position: absolute;
      padding: px2Rem(11px) px2Rem(20px);
      top: 0;
      right: px2Rem(190px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      border-radius: 0px 0px 0px 8px;
      background: rgba(0, 0, 0, 0.5);
    }
    .div {
      position: relative;
      width: px2Rem(1200px);
      // height: px2Rem(500px);
      padding-bottom: px2Rem(40px);
      margin: px2Rem(20px) auto px2Rem(0px);
      --swiper-theme-color: #e2bb81;
      .swiper-button-next,
      .swiper-button-prev {
        width: px2Rem(12px);
        height: px2Rem(22px);
        top: 42%;
        outline: none;
        &::after {
          display: none;
        }
        img {
          width: px2Rem(12px);
          height: px2Rem(22px);
        }
      }
      .swiper-button-prev {
        left: px2Rem(-20px);
      }
      .swiper-button-next {
        right: px2Rem(-20px);
      }
      .swiperslide {
        width: px2Rem(230px) !important;
        height: px2Rem(150px);
        margin: auto;
      }
      .swiperDiv {
        position: relative;
        width: px2Rem(230px);
        height: px2Rem(150px);
        cursor: pointer;
        &::after {
          display: block;
          content: "";
          position: absolute;
          background: rgba(0, 0, 0, 0.4);
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .foodImg {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      /deep/ .swiper-slide-active {
        .swiperDiv {
          &::after {
            display: block;
            content: "";
            position: absolute;
            background: rgba(0, 0, 0, 0);
            width: 0%;
            height: 0%;
            top: 0;
            left: 0;
          }
        }
      }
      .myswiper {
        width: px2Rem(1200px);
        margin: auto;
        text-align: center;
      }
    }
    .content {
      position: relative;
      margin: px2Rem(30px) 0;
      &:hover {
        .swiper-button-next,
        .swiper-button-prev {
          // visibility: hidden;
          opacity: 1;
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        width: px2Rem(100px);
        height: 100%;
        top: 0%;
        outline: none;
        transition: 0.5s;
        margin-top: 0;
        // visibility: hidden;
        opacity: 0;
        &::after {
          display: none;
        }
        &:hover {
          background: rgba(0, 0, 0, 0.1);
          // opacity:0.1;
          i {
            color: #fff;
          }
        }
        img {
          width: px2Rem(12px);
          height: px2Rem(22px);
        }
        i {
          font-size: 40px;
          color: #6c6c6c;
        }
      }
      .swiper-button-prev {
        left: px2Rem(50px);
      }
      .swiper-button-next {
        right: px2Rem(50px);
      }
    }
  }
}
.notGall{
  padding: px2Rem(40px) 0;
  font-size: px2Rem(50px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/index/GalleryDetail.vue